<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema, $ } from '@bagelink/vue'
const defaults = {
	tag: '',
	title: 'Page Title',
	hebrew: '',
	book: '',
	haftarah: '',
	subtitle: '',
}
const schema = defineSchema({
	tag: $.text('Tag'),
	title: $.text('Title'),
	hebrew: $.text('Hebrew'),
	book: $.text('Book'),
	haftarah: $.text('Haftarah'),
	subtitle: $.text('Subtitle'),
})
export const BlockTitle = defineBlock({ thumbnail: '/block-thumbs/BlockTitle.svg', category: 'Content', order: 280, name: 'BlockTitle', label: 'Page Title', icon: 'title', schema, defaults })
</script>
<script setup lang="ts">


const props = defineProps<{
	tag?: string
	title?: string
	hebrew?: string
	book?: string
	haftarah?: string
	subtitle?: string
}>()
</script>

<template>
	<div class="w720px mx-auto pt-2-5 pb-1-5 txt-center m_pt-2 m_pb-1">
		<!-- Tag/Category Label -->
		<p v-if="props.tag" class="txt13 color-gray-70 pt-1 light pb-025">
			{{ props.tag }}
		</p>
		<!-- Main Title -->
		<h1 class="my-0 txt40 regular line-height-14 m_txt32">
			{{ props.title }}
			<span v-if="props.hebrew" class="txt49 m_txt38">
				{{ props.hebrew }}
			</span>
		</h1>
		<!-- Subtitle -->
		<p v-if="props.subtitle" class="txt17 pt-1-5 m_px-1 m_txt15">
			{{ props.subtitle }}
		</p>
		<!-- Book and Haftarah -->
		<i v-if="props.book || props.haftarah" class="txt17 color-gray-70 light pt-05 block">
			<span v-if="props.book">
				{{ props.book }}
			</span>
			<span v-if="props.book && props.haftarah" class="px-1" />
			<span v-if="props.haftarah">
				{{ props.haftarah }}
			</span>
		</i>
	</div>
</template>
